import { studentFetch, guardianFetch } from '../utils/authFetch';
import { clearPinVerification } from './pinSession';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const BACKEND_TIMEOUT_MS = 2500;

/**
 * Logs out: tells the backend to invalidate the session, then clears
 * local state. Safe to call even if the backend call fails — local state
 * is always cleared.
 *
 * @param {"student"|"guardian"} userType
 */
export async function logoutAndClearLocal(userType) {
  const endpoint =
    userType === 'student'
      ? `${API}/auth/student/session/logout`
      : `${API}/auth/guardian/session/logout`;
  const fetchFn = userType === 'student' ? studentFetch : guardianFetch;

  // Best-effort backend notification — give it up to 2.5s, then proceed
  try {
    await Promise.race([
      fetchFn(endpoint, { method: 'POST' }),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('logout timeout')), BACKEND_TIMEOUT_MS)
      ),
    ]);
  } catch {
    // Network error, 401, timeout — proceed with local clear anyway
  }

  // Always clear local state, regardless of backend outcome
  if (userType === 'student') {
    localStorage.removeItem('student_token');
    clearPinVerification();
    localStorage.removeItem('student_data');
  } else {
    localStorage.removeItem('jahbath_token');
    localStorage.removeItem('jahbath_guardian_id');
  }
}
